import { jsx, jsxs } from 'react/jsx-runtime';
import React__default, { useMemo } from 'react';
import { styled, css } from 'styled-components';
import { IconCheck } from '@fabric-app/icons/old';
import { sortColorLabels } from '../../labels.utils.js';
import { useMutationChangeResourceLabel } from '../../../resource-detail/mutations/useMutationChangeResourceLabel.js';
import { mediaHover } from '@fabric-app/ui/constants/styled-utils';
import { getTextColor } from '@fabric-app/utils/color';
import { IconPlusSmall } from '@fabric-app/icons/svg';

const LabelSelectorContainer = styled.div.withConfig({
  displayName: "LabelSelector__LabelSelectorContainer",
  componentId: "sc-ea389f0c-0"
})([
  `grid-template-columns:repeat(5,1fr);display:grid;padding:8px 7px;`
]);
const IconTransition = css([
  `transition:all 200ms ease-in-out;pointer-events:none;`
]);
const StyledIconCheck = styled(IconCheck).withConfig({
  displayName: "LabelSelector__StyledIconCheck",
  componentId: "sc-ea389f0c-1"
})([
  `opacity:0;width:12px;height:auto;`,
  ``
], IconTransition);
const StyledIconPlus = styled(IconPlusSmall).withConfig({
  displayName: "LabelSelector__StyledIconPlus",
  componentId: "sc-ea389f0c-2"
})([
  `width:16px;height:16px;opacity:1;`
]);
const BubbleButton = styled.button.withConfig({
  displayName: "LabelSelector__BubbleButton",
  componentId: "sc-ea389f0c-3"
})([
  `display:flex;align-items:center;justify-content:center;padding:6px;&[data-selected='true']{> span{background-color:#0078d4;}`,
  `{opacity:1;}}`,
  `{&:hover{> span{transform:scale(1.67);}`,
  `{transform:scale(0);opacity:0;}&[data-selected='true']{`,
  `{transform:rotate(45deg) scale(1);}}}}&[data-other-hover='true']{&[data-selected='true']{`,
  `{transform:rotate(45deg) scale(0.8);}}`,
  `{transform:scale(0);opacity:0;}}&:not(:hover):not([data-other-hover='true']){`,
  `{transform:scale(0);opacity:0;}}> span{display:flex;align-items:center;justify-content:center;width:18px;height:18px;border-radius:20px;transition:transform 100ms ease-in-out;transform-origin:center;}> svg{position:absolute;}`
], StyledIconCheck, mediaHover, StyledIconCheck, StyledIconPlus, StyledIconPlus, StyledIconCheck, StyledIconPlus);
const LabelSelector = ({ resources, spaceId, colorLabels }) => {
  const sortedColorLabels = useMemo(() => sortColorLabels(colorLabels), [
    colorLabels
  ]);
  const [hoveredLabel, setHoveredLabel] = React__default.useState(null);
  const mutationChangeResourceLabel = useMutationChangeResourceLabel();
  const handleLabelClick = async (colorLabel) => {
    if (resources.length < 1 || !spaceId) return;
    try {
      const nextLabel = resources.every((resource) => resource.label?.id === colorLabel.id) ? null : colorLabel;
      resources.forEach((fdoc) => {
        mutationChangeResourceLabel.mutate({
          resourceId: fdoc.id,
          label: nextLabel
        });
      });
    } catch (e) {
      console.error(e);
    }
  };
  return /* @__PURE__ */ jsx(LabelSelectorContainer, {
    children: sortedColorLabels.map((colorLabel) => {
      const selected = resources.find((f) => f.label?.id === colorLabel.id) && (resources.length < 2 || resources.length > 1 && hoveredLabel !== colorLabel);
      return /* @__PURE__ */ jsxs(BubbleButton, {
        "data-selected": selected,
        "data-other-hover": resources.length > 1 && hoveredLabel && selected && hoveredLabel !== colorLabel,
        style: {
          color: getTextColor(colorLabel.hexColor)
        },
        onClick: () => handleLabelClick(colorLabel),
        onMouseEnter: () => setHoveredLabel(colorLabel),
        onMouseLeave: () => setHoveredLabel(null),
        children: [
          /* @__PURE__ */ jsx("span", {
            style: {
              backgroundColor: colorLabel.hexColor
            }
          }),
          /* @__PURE__ */ jsx(StyledIconPlus, {}),
          /* @__PURE__ */ jsx(StyledIconCheck, {})
        ]
      }, colorLabel.id);
    })
  });
};

export { LabelSelector as default };
//# sourceMappingURL=LabelSelector.js.map
